import axios from "../../../../../axios";
import Cookies from "js-cookie";


// services/jobService.js
// Author: Sanket Raut 23-july-2025
// API: Get All Publish Jobs
export const getPublishJobs = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Jobs/Employee/GetPublishedJobs", {
    token,
  });
};

// Author: Harshada Bhavsar 17-12-2025
//  Get Job Opening Limit by JobUID
export const getJobOpeningLimit = async (jobUID) => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Jobs/GetJobOpeningLimit", {
    token,
    jobUID,
  });
};